export const VOLUME_VALUES = {
  MIN: 0,
  MAX: 1,
};
